// Alfabeto fonetico ICAO → lettera
const ICAO_LETTERE: Record<string, string> = {
  alpha: 'A', alfa: 'A',
  bravo: 'B',
  charlie: 'C',
  delta: 'D',
  echo: 'E',
  foxtrot: 'F',
  golf: 'G',
  hotel: 'H',
  india: 'I',
  juliet: 'J', juliett: 'J',
  kilo: 'K',
  lima: 'L',
  mike: 'M',
  november: 'N',
  oscar: 'O',
  papa: 'P',
  quebec: 'Q',
  romeo: 'R',
  sierra: 'S',
  tango: 'T',
  uniform: 'U',
  victor: 'V',
  whiskey: 'W',
  xray: 'X', 'x-ray': 'X',
  yankee: 'Y',
  zulu: 'Z',
};

// Parole numeriche (italiano + ICAO standard) → cifra
const ICAO_NUMERI: Record<string, string> = {
  zero: '0', nadazero: '0',
  uno: '1', unaone: '1', one: '1',
  due: '2', bissotwo: '2', two: '2',
  tre: '3', terrathree: '3', three: '3',
  quattro: '4', kartefour: '4', four: '4',
  cinque: '5', pantafive: '5', five: '5',
  sei: '6', soxisix: '6', six: '6',
  sette: '7', setteseven: '7', seven: '7',
  otto: '8', oktoeight: '8', eight: '8',
  nove: '9', novenine: '9', nine: '9',
};

/**
 * Converte testo dettato in alfabeto ICAO nella sigla corrispondente.
 * Es: "Tango Foxtrot zero uno quattro" → "TF 014"
 * Es: "TF 0 1 4" → "TF 014"
 */
export function parseICAOSigla(testo: string): string {
  const parole = testo.trim().toLowerCase().split(/[\s\-]+/).filter(Boolean);
  const caratteri: string[] = [];

  for (const parola of parole) {
    if (ICAO_LETTERE[parola]) {
      caratteri.push(ICAO_LETTERE[parola]);
    } else if (ICAO_NUMERI[parola]) {
      caratteri.push(ICAO_NUMERI[parola]);
    } else if (/^[a-z]$/.test(parola)) {
      caratteri.push(parola.toUpperCase());
    } else if (/^\d$/.test(parola)) {
      caratteri.push(parola);
    }
    // parole non riconosciute vengono ignorate
  }

  const normalizza = (s: string) =>
    s.replace(/([A-Z])(\d)/g, '$1 $2').replace(/(\d)([A-Z])/g, '$1 $2');

  if (caratteri.length === 0) return normalizza(testo.toUpperCase().trim());

  // Inserisce uno spazio alla transizione lettere→cifre (es. TF→014)
  return normalizza(caratteri.join(''));
}
